// Price helpers for the collection grid's market tile.

const roundTo = (sats: number) => {
	const step = sats >= 10_000_000 ? 10_000 : sats >= 1_000_000 ? 1_000 : sats >= 100_000 ? 100 : 10
	return Math.max(1_000, Math.round(sats / step) * step)
}

/** One-tap starting prices below floor. Empty when there is no floor to anchor to. */
export function bidAnchors(floorSats: number | null | undefined) {
	if (!floorSats || floorSats < 2_000) return []
	return [5, 10, 20].map((pct) => ({
		label: `−${pct}%`,
		sats: roundTo(floorSats * (1 - pct / 100))
	}))
}

/**
 * The smallest sensible bid above the current top: +1%, never at or above the
 * floor (at floor you would simply buy the listing).
 */
export function nextBidAbove(topSats: number, floorSats: number | null | undefined) {
	const next = roundTo(topSats * 1.01)
	const raised = next > topSats ? next : topSats + 10
	if (floorSats && raised >= floorSats) return Math.max(topSats, floorSats - 10)
	return raised
}

export function percentOf(sats: number, floorSats: number | null | undefined) {
	if (!floorSats || floorSats <= 0) return null
	return Math.round((sats / floorSats) * 100)
}
